<template>
    <div class="register__section">

        <div class="register__wrapper">
            <h2 class="register__heading h1" v-translate>registration_step_1_title</h2>
            <div class="register__intro" v-translate>registration_step_1_intro</div>
            <!-- <label class="register__image" :class="{'is-loading': imageUploading}">
                <transition name="fade-slow">
                    <div v-if="!imagePreviewUrl" class="register__image__empty">
                        <icon name="camera" class="register__image__empty__icon"></icon>
                    </div>
                </transition>
                <transition name="fade-slow">
                    <img v-if="imagePreviewUrl" class="register__image__preview" :src="imagePreviewUrl"/>
                </transition>
                <transition name="fade-slow">
                    <loader class="register__image__preloader" v-if="imageUploading" color="white"></loader>
                </transition>
                <input type="file" class="register__image__input" accept="image/*" @change="onImageFileChange"/>
            </label> -->
        </div>

        <div class="register__wrapper register__wrapper--small">
            <div class="register__form form">
                <!-- <div class="form__row">
                    <div class="form__item">
                        <input @input="requiredFieldChange" v-model="registrationUser.name" type="text" class="form__field form__field--text" :placeholder="placeholders.name + '*'" :class="{'is-error': errors.indexOf('name') >= 0}"/>
                        <div class="form__error" v-if="errors.indexOf('name') >= 0">"{{placeholders.name}}" <translate>form_field_required</translate></div>
                    </div>
                </div> -->


                <div class="form__row">
                    <div class="form__item">
                        <input @input="requiredFieldChange" v-model="registrationUser.firstName" type="text" class="form__field form__field--text" :placeholder="placeholders.firstName + '*'" :class="{'is-error': errors.indexOf('firstName') >= 0}"/>
                        <div class="form__error" v-if="errors.indexOf('firstName') >= 0">"{{placeholders.firstName}}" <translate>form_field_required</translate></div>
                    </div>
                </div>

                <div class="form__row">
                    <div class="form__item">
                        <input @input="requiredFieldChange" v-model="registrationUser.lastName" type="text" class="form__field form__field--text" :placeholder="placeholders.lastName + '*'" :class="{'is-error': errors.indexOf('lastName') >= 0}"/>
                        <div class="form__error" v-if="errors.indexOf('lastName') >= 0">"{{placeholders.lastName}}" <translate>form_field_required</translate></div>
                    </div>
                </div>

    
                <div class="form__row form__row--multiple">
                    <div class="form__item form__item--date form__item--half">
                        <svg class="icon form__icon"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                        >
                            <g>
                                <path class="st0" d="M19,4H5C4.4,4,4,4.4,4,5v14c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1V5C20,4.4,19.6,4,19,4z M19,19H5V8.5h14V19z
                                    M19,7.5H5V5h14V7.5z"/>
                                <rect x="7" y="10.5" class="st0" width="2" height="2"/>
                                <rect x="11" y="10.5" class="st0" width="2" height="2"/>
                                <rect x="15" y="10.5" class="st0" width="2" height="2"/>
                                <rect x="7" y="14.5" class="st0" width="2" height="2"/>
                                <rect x="11" y="14.5" class="st0" width="2" height="2"/>
                                <rect x="15" y="14.5" class="st0" width="2" height="2"/>
                            </g>
                        </svg>

                        <datepicker
                            :value="registrationUser.dob"
                            @input="handleDateChange"
                            format="yyyy-MM-dd"
                            input-class="form__field" 
                            :placeholder="placeholders.birthDate" 
                            initial-view="year"
                            :disabled-dates="disabledDates"
                            :open-date="initialDate"
                            :use-utc="true"
                        ></datepicker>
                        <!-- <div class="form__error" v-if="errors.indexOf('dob') >= 0">"{{placeholders.birthDate}}" <translate>form_field_required</translate></div> -->
                    </div>
                    <div class="form__item form__item--half">
                        <v-select 
                            class="form__v-select" 
                            v-model="registrationUser.sex" 
                            :reduce="item => item.code"
                            :options="genderOptions" 
                            :placeholder="placeholders.gender"                  
                        ></v-select>
                    </div>
                </div>

                 <div class="form__row">
                    <div class="form__item">
                        <!-- <input @input="requiredFieldChange" v-model="registrationUser.location" type="text" class="form__field form__field--text" :placeholder="placeholders.location + '*'" :class="{'is-error': errors.indexOf('location') >= 0}"/> -->
                        <v-select 
                            class="form__v-select" 
                            :class="{'is-error': errors.indexOf('location') >= 0}"
                            @input="requiredFieldChange"
                            v-model="registrationUser.location" 
                            :reduce="item => item.label"
                            :options="countryOptions[0]" 
                            :placeholder="placeholders.location + '*'"                  
                        ></v-select>
                        <div class="form__error" v-if="errors.indexOf('location') >= 0">"{{placeholders.location}}" <translate>form_field_required</translate></div>
                    </div>
                </div>

                <!-- <div class="form__row form__row--multiple">
                    <div class="form__item form__item--half">
                        <input :value="weight" @change="weightChanged" type="number" :min="minWeight" :max="maxWeight" class="form__field form__field--number " :placeholder="placeholders.weight"/>
                        <div class="register__units">
                            <div class="register__units__item" :class="{'is-unit-active': weightUnit === 'kg'}" @click="switchWeightUnit('kg');" v-translate>kg</div>
                            <div class="register__units__item" :class="{'is-unit-active': weightUnit === 'lbs'}" @click="switchWeightUnit('lbs');" v-translate>lbs</div>
                        </div>
                    </div>
                    <div class="form__item form__item--half register__height-area" :class="{'is-feet': heightUnit === 'ft'}">
                        <input 
                            :value="height" 
                            @change="heightChanged" 
                            type="number" 
                            :min="minHeight" 
                            :max="maxHeight" 
                            class="form__field form__field--number  register__height-area__field" 
                            :placeholder="heightUnit === 'cm' ? placeholders.height : placeholders.feet_abbr"
                        />
                        <span class="register__height-area__separator">'</span>
                        <input :value="heightInches" @change="heightInchesChanged" type="number" :min="minHeightInches" :max="maxHeightInches" v-if="heightUnit === 'ft'" class="form__field form__field--number  register__height-area__field" :placeholder="placeholders.inch_abbr"/>
                        <span class="register__height-area__separator">"</span>
                        <div class="register__units">
                            <div class="register__units__item" :class="{'is-unit-active': heightUnit === 'cm'}" @click="switchHeightUnit('cm');" v-translate>cm</div>
                            <div class="register__units__item" :class="{'is-unit-active': heightUnit === 'ft'}" @click="switchHeightUnit('ft');" v-translate>feet_abbr</div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import { presign, postToS3 } from '../api'
import _ from 'lodash'
import { mapState } from 'vuex';
import Datepicker from 'vuejs-datepicker';
import countries from '../data/countries';

export default {
    components: {
        Datepicker
    },
    props: {
        errors: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            initialDate: new Date(1990, 1, 1),
            disabledDates: {
                to: new Date(1900, 0, 0),
                from: new Date(2016, 0, 0)
            },
            // imageFile: null,
            // imagePreviewUrl: null,
            // imageUploading: false,
            // weight: null,
            // minWeight: 30,
            // maxWeight: 199,
            // weightUnit: 'kg',
            // height: null,
            // heightInches: null,
            // minHeight: 120,
            // maxHeight: 219,
            // minHeightInches: 0,
            // maxHeightInches: 11,
            // heightUnit: 'cm'
        }
    },
    mounted() {
        console.log(this.countryOptions);
        // setTimeout(() => {
        //     // if(this.registrationUser.weight) {
        //     //     this.weight = this.registrationUser.weight;
        //     // }
        //     // if(this.registrationUser.height) {
        //     //     this.height = this.registrationUser.height;
        //     // }
        //     if(this.registrationUser.profileImageUrl){
        //         this.imageUploading = true;
        //         this.imagePreviewUrl = this.registrationUser.profileImageUrl;
        //         this.toDataURL(this.registrationUser.profileImageUrl, (response) => {
        //             this.urltoFile(response, 'image.jpg','image/jpeg')
        //             .then(file => { 
        //                 this.uploadImage(file)
        //             });
        //         });
        //     }
        // }, 1);
    },
    computed: {
        placeholders() {
            return {
                // name: this.$gettext('first_and_last_name'),
                firstName: this.$gettext('first_name'),
                lastName: this.$gettext('last_name'),
                location: this.$gettext('location'),
                birthDate: this.$gettext('birth_date'), 
                gender: this.$gettext('gender'),
                // weight: this.$gettext('weight'),
                // height: this.$gettext('height'),
                feet_abbr: this.$gettext('feet_abbr'),
                inch_abbr: this.$gettext('inch_abbr'),
            }
        },
        genderOptions() {
            return [
                {
                    label: this.$gettext('male'),
                    code: 'm'
                },
                {
                    label: this.$gettext('female'),
                    code: 'f'
                },
                {
                    label: this.$gettext('non_binary'),
                    code: 'd'
                },
            ]
        }, 
        
        countryOptions() {
            return [
                _.map(countries, (countryName, countryKey) => {
                    return {
                        code: countryKey,
                        label: countryName,
                    }
                })
            ];
        },

        ...mapState({
            'registrationUser': 'registrationUser'
        }),
    },
    methods: {
        requiredFieldChange() {
            this.$emit('changed');
        },
        handleDateChange(date) {
            if(!date || date === '') {
                return null;
            }
            this.$store.commit('setRegistrationUserDOB', date.toISOString().split('T')[0]);
            this.requiredFieldChange();
        },
        // onImageFileChange(e) {
        //     const file = e.target.files[0]
        //     this.imageFile = file
        //     this.imagePreviewUrl = URL.createObjectURL(file)
        //     this.uploadImage(file);
        // },
        // async uploadImage(file) {
        //     this.imageUploading = true;
        //     try {
        //         let presignResponse = await presign()
        //         const presignResponseData = presignResponse.data;
        //         let imageKey = presignResponseData.fields.key;
        //         let s3Response = await postToS3(presignResponseData, file);
        //         this.$store.commit('setRegistrationUserProfileImageKey', imageKey);
        //     } catch(e) {
        //         console.error(e);
        //     } finally {
        //         this.imageUploading = false;
        //     }
        // },
        // toDataURL(src, callback) {
        //     var image = new Image();
        //     image.crossOrigin = 'Anonymous';
        
        //     image.onload = function() {
        //         var canvas = document.createElement('canvas');
        //         var context = canvas.getContext('2d');
        //         canvas.height = this.naturalHeight;
        //         canvas.width = this.naturalWidth;
        //         context.drawImage(this, 0, 0);
        //         var dataURL = canvas.toDataURL('image/jpeg');
        //         callback(dataURL);
        //     };

        //     image.src = src;
        // },
        // urltoFile(url, filename, mimeType){
        //     return (fetch(url)
        //         .then(function(res){return res.arrayBuffer();})
        //         .then(function(buf){return new File([buf], filename,{type:mimeType});})
        //     );
        // },
        // weightChanged(e) {
        //     let value = parseInt(e.target.value);
        //     this.storeWeight(value);
        // },
        // storeWeight(value) {
        //     if(isNaN(value)) {
        //         value = null;
        //     } else if(value < this.minWeight) {
        //         value = this.minWeight;
        //     } else if (value > this.maxWeight) {
        //         value = this.maxWeight;
        //     }
        //     this.weight = value;
        //     if(this.weightUnit === 'lbs') {
        //         value = this.convertLbsToKg(value);
        //     }
        //     this.$store.commit('setRegistrationUserWeight', value);
        // },
        // switchWeightUnit(unit) {
        //     if(unit === this.weightUnit) {
        //         return false;
        //     }
        //     this.weightUnit = unit;
        //     if(unit === 'lbs') {
        //         this.minWeight = 66;
        //         this.maxWeight = 439;
        //         if(this.weight){
        //             this.weight = this.convertKgToLbs(this.weight);
        //             this.storeWeight(this.weight);
        //         }
        //     } else {
        //         this.minWeight = 30;
        //         this.maxWeight = 199;
        //         if(this.weight){
        //             this.weight = this.convertLbsToKg(this.weight);
        //             this.storeWeight(this.weight);
        //         }
        //     }
        // },
        // heightChanged(e) {
        //     let value = parseInt(e.target.value);
        //     if(this.heightUnit === 'ft') {
        //         value = {feet: value, inches: this.heightInches}
        //     }
        //     this.storeHeight(value);
        // },
        // heightInchesChanged(e) {
        //     let value = parseInt(e.target.value);
        //     if(this.heightUnit === 'ft') {
        //         value = {feet: this.height, inches: value}
        //     }
        //     this.storeHeight(value);
        // },
        // storeHeight(value) {
        //     let valuePrimary;
        //     let valueSecondary;
        //     if(this.heightUnit === 'ft') {
        //         valuePrimary = value.feet ? value.feet : 4;
        //         valueSecondary = value.inches ? value.inches : 0;
        //         value = valuePrimary;
        //     }
        //     if(isNaN(value)) {
        //         value = null;
        //     } else if(value < this.minHeight) {
        //         value = this.minHeight;
        //     } else if (value > this.maxHeight) {
        //         value = this.maxHeight;
        //     }
        //     this.height = value;
        //     if(isNaN(valueSecondary)) {
        //         valueSecondary = null;
        //     } else if(valueSecondary < this.minHeightInches) {
        //         valueSecondary = this.minHeightInches;
        //     } else if (valueSecondary > this.maxHeightInches) {
        //         valueSecondary = this.maxHeightInches;
        //     }
        //     this.heightInches = valueSecondary;
        //     if(this.heightUnit === 'ft') {
        //         value = this.convertColonialToMetricHeight();
        //     }
        //     this.$store.commit('setRegistrationUserHeight', value);
        // },
        // switchHeightUnit(unit) {
        //     if(unit === this.heightUnit) {
        //         return false;
        //     }
        //     this.heightUnit = unit;
        //     if(unit === 'cm') {
        //         this.minHeight = 120;
        //         this.maxHeight = 219;
        //         if(this.height){
        //             this.height = this.convertColonialToMetricHeight();
        //             this.storeHeight(this.height);
        //         }
        //     } else {
        //         this.minHeight = 4;
        //         this.maxHeight = 7;
        //         if(this.height){
        //             let heightConverted = this.convertMetricToColonialHeight();
        //             this.height = heightConverted.feet;
        //             this.heightInches = heightConverted.inches;
        //             this.storeHeight({feet: this.height, inches: this.heightInches});
        //         }
        //     }
        // },
        // convertKgToLbs(value) {
        //     return Math.round(value * 2.204623);
        // },
        // convertLbsToKg(value) {
        //     return Math.round(value / 2.204623);
        // },
        // convertColonialToMetricHeight() {
        //     let feet = (this.height * 12) + this.heightInches;
        //     return Math.round(feet / 0.39);
        // },
        // convertMetricToColonialHeight() {
        //     let totalInches = this.height * 0.39;
        //     let totalFeet = totalInches / 12;
        //     let feet = Math.floor(totalFeet);
        //     let totalFeetDecimal = totalFeet - feet;
        //     let inches = totalFeetDecimal * 12;
        //     return {feet: Math.round(feet), inches: Math.round(inches)};
        // }
    

    }
}
</script>

<style lang="scss">
// styles in "RegistrationSteps" component
</style>
